import { Alert, AlertIcon, Box, Link, Text } from '@chakra-ui/react';
import JobsManagement from '../SidePages/FoldersContainer';
import Chatbot from '../../components/ChatBot/Chatbot';

const IntroductionPage = () => {
  return (
    <Box bg="white" minH="calc(100vh - 120px)">
      <Alert status="info" variant="subtle" bg="surface.200" borderRadius="md" mx={4} mt={4} borderLeft="4px solid" borderLeftColor="primary.500">
        <AlertIcon color="primary.500" />
        <Text fontSize="sm" color="primary.500">
          <Text as="span" fontWeight="bold">Beta Release:</Text> This product is in active development. Users may experience limited functionality or unexpected behavior in certain use cases. If you encounter any issues, please contact us via{' '}
          <Link href="https://seq4life.com" isExternal color="secondary.500" fontWeight="medium">
            seq4life.com
          </Link>{' '}
          so we can promptly investigate and resolve them. We appreciate your patience and support as we continue to refine and improve the platform.
        </Text>
      </Alert>
      <JobsManagement />
      <Box flexShrink={0}>
        <Chatbot />
      </Box>
    </Box>
  );
};

export default IntroductionPage;
